var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCulture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.culture-st0{fill:#FFFFFF;stroke:currentColor;stroke-width:10;stroke-miterlimit:10;}\r\n\t.culture-st1{fill:#FFFFFF;stroke:currentColor;stroke-width:11;stroke-miterlimit:10;}\r\n\t.culture-st2{fill:none;stroke:currentColor;stroke-width:10.4661;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "culture-st0",
    d: "M288.5,323.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "culture-st1",
    d: "M293.5,35c-34.7-9-72.8-13.5-113.5-13.5s-79.4,5-113.5,13.5v256.5c34.7,9,72.8,13.5,113.5,13.5 s79.5-5,113.5-13.5V35z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121.8,
    y: 69.7,
    className: "culture-st2",
    width: 116.3,
    height: 61.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "culture-st1",
    points: "66.5,295.4 66.5,337 101.8,301.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "culture-st1",
    points: "293.5,295.4 293.5,337 258.2,301.7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulture);
export default __webpack_public_path__ + "static/media/culture.88d4b1937ae8dff9beb652dd76717221.svg";
export { ForwardRef as ReactComponent };